module.exports = __webpack_public_path__ + "img/pay-intro.c10ff796.png";